import ClinicianPortalBreadcrumbs from './ClinicianPortalBreadcrumbs'

export default ClinicianPortalBreadcrumbs
